import { render, staticRenderFns } from "./IframeComponent.vue?vue&type=template&id=9f62814c"
import script from "./IframeComponent.vue?vue&type=script&lang=js"
export * from "./IframeComponent.vue?vue&type=script&lang=js"
import style0 from "./IframeComponent.vue?vue&type=style&index=0&id=9f62814c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports